"use strict";
const _ = require("lodash");

class ResponsiveUtility {
  phone() {
    console.log("hello phone");
  }
  tablet() {
    console.log("hello tablet");
  }
  desktop() {
    console.log("hello desktop");
  }
  huge() {
    console.log("hello huge");
  }
  findBreakpoint() {
    if (window.innerWidth < window.PHONE_BREAKPOINT) {
      return "phone";
    }
    if (window.innerWidth < window.TABLET_BREAKPOINT) {
      return "tablet";
    }
    if (window.innerWidth < window.DESKTOP_BREAKPOINT) {
      return "desktop";
    }
    return "huge";
  }
  runFunctions(type) {
    switch (type) {
      case "huge":
        this.huge();
        break;
      case "desktop":
        this.desktop();
        break;
      case "tablet":
        this.tablet();
        break;
      case "phone":
        this.phone();
        break;

      default:
        break;
    }
  }
  constructor(options) {
    if (options.phone) {
      this.phone = options.phone;
    }
    if (options.tablet) {
      this.tablet = options.tablet;
    }
    if (options.desktop) {
      this.desktop = options.desktop;
    }
    if (options.huge) {
      this.huge = options.huge;
    }
    let isMobile = this.findBreakpoint();
    const calc = el => {
      let current = this.findBreakpoint();
      if (current != isMobile) {
        isMobile = current;
        this.runFunctions(isMobile);
      } else {
        isMobile = current;
      }
    };

    $(window).resize(
      _.debounce(() => {
        calc(this);
      }, 100)
    );
    calc(this);
    this.runFunctions(isMobile);
  }
}

module.exports = {
  ResponsiveUtility
};